export default (node) => {
  /**
   * Data + elements
   */
  const pageLoaderSection = document.getElementById(
    'shopify-section-page-loader'
  );
  const logoAnimation = node.querySelector('[data-logo-animation]');

  /**
   * Functions
   */

  /**
   * Init
   */
  const init = () => {
    setTimeout(() => {
      pageLoaderSection.classList.add('hidden');
      sessionStorage.setItem('page-loader', 'loaded');
    }, 1000);

    if (sessionStorage.getItem('page-loader') === 'loaded') {
      pageLoaderSection.classList.add('hidden');
      return;
    }

    logoAnimation.addEventListener('animationend', () => {
      node.classList.add('is-loaded');
    });

    node.addEventListener('animationend', ({ target }) => {
      if (target === node) {
        pageLoaderSection.classList.add('hidden');
      }
      sessionStorage.setItem('page-loader', 'loaded');
    });
  };

  init();
};
